import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed } from 'vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { mainBodyList, mainBodyDetail } from '@/api/overseasSales/customerCenter'
import { arkCodeStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { useRoute } from 'vue-router'
import { tableIdByPath } from '@/utils'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'tabsMainBody' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const route = useRoute()

const columns = computed(() => [
  { title: t('mainBody.customerCode'), dataIndex: 'customerCode' },
  { title: t('mainBody.accountCode'), dataIndex: 'accountCode', headerQuestion: t('mainBody.accountCodeDesc') },
  { title: t('mainBody.signBodyName'), dataIndex: 'signBodyName', headerQuestion: t('mainBody.signBodyNameDesc') },
  { title: t('mainBody.serviceBodyName'), dataIndex: 'serviceBodyName', headerQuestion: t('mainBody.serviceBodyNameDesc') },
  {
    title: t('mainBody.bodyContactName'),
    dataIndex: 'contactName',
    cosType: 'mask',
    headerQuestion: t('mainBody.contactNameDesc'),
    width: 130
  },
  {
    title: t('mainBody.bodyPhoneNumber'),
    dataIndex: 'phoneNumber',
    cosType: 'mask',
    headerQuestion: t('mainBody.phoneNumberDesc'),
    width: 145
  },
  {
    title: t('mainBody.signBodyBalanceList'),
    dataIndex: 'signBodyBalanceList',
    headerQuestion: t('mainBody.signBodyBalanceListDesc'),
    width: 200
  },
  { title: t('mainBody.totalQuota'), dataIndex: 'totalQuota', headerQuestion: t('mainBody.totalQuotaDesc') },
  { title: t('mainBody.allTotal'), dataIndex: 'allTotal', headerQuestion: t('mainBody.allTotalDesc'), width: 130 },
  { title: t('mainBody.accountCycleTypeStr'), dataIndex: 'accountCycleTypeStr', headerQuestion: t('mainBody.accountCycleType') },
  { title: t('mainBody.reconciliationCycleTypeStr'), dataIndex: 'reconciliationCycleTypeStr', headerQuestion: t('mainBody.reconciliationCycleType') },
  { title: t('mainBody.signBusinessTypeStr'), dataIndex: 'signBusinessTypeStr', headerQuestion: t('mainBody.signBusiness') },
  {
    title: t('mainBody.contractedBusinessStr'),
    dataIndex: 'contractedBusinessStr',
    headerQuestion: t('mainBody.contractedBusinessDesc'),
    width: 130
  },
  {
    title: t('mainBody.registerAreaCode'),
    dataIndex: 'registerAreaCode',
    headerQuestion: t('mainBody.registerAreaCodeDesc'),
    width: 160
  },
  {
    title: t('mainBody.signBodyType'),
    dataIndex: 'type',
    dicData: [
      { value: 'C101', label: t('mainBody.C101') },
      { value: 'C102', label: t('mainBody.C102') }
    ],
    headerQuestion: t('mainBody.typeDesc')
  },
  {
    title: t('mainBody.signBodyStatus'),
    dataIndex: 'signBodyStatus',
    dicData: arkCodeStatusEnum,
    headerQuestion: t('mainBody.signBodyStatusDesc')
  },
  { title: t('mainBody.examineTime'), dataIndex: 'examineTime', headerQuestion: t('mainBody.examineTimeDesc'), width: 190 },
  {
    title: t('mainBody.sellerName'),
    dataIndex: ['customer', 'sellerName'],
    headerQuestion: t('mainBody.sellerNameDesc'),
    width: 130
  },
  { title: t('mainBody.sellerRegion'), dataIndex: ['customer', 'sellerRegion'], width: 190 }
])
const getList = (queryForm: any, callBack: (res: any) => void) => {
  if (route.query.cosId) {
    mainBodyList({
      customer: {
        cosId: route.query.cosId
      },
      ...queryForm
    }).then((res) => {
      callBack(res)
    })
  }
}

// 获取详情信息
const showMask = (record: any, callBack: (res: any) => void) => {
  mainBodyDetail({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    columns: columns.value,
    onFetch: getList,
    onMask: showMask,
    tableId: _unref(tableIdByPath)('mainBody')
  }, {
    bodyCell: _withCtx(({ column, text }) => [
      (column.dataIndex === 'customer.sellerRegion')
        ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
            key: 0,
            appId: "cos_ofbu",
            value: text
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (column.dataIndex === 'signBodyBalanceList')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(text?.map((item) => `${item.currencyCode}：${item.quota}`).join('、') || '--'), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "tableId"]))
}
}

})